import { render, staticRenderFns } from "./GarageUpdates.vue?vue&type=template&id=18673736&scoped=true"
import script from "./GarageUpdates.vue?vue&type=script&lang=js"
export * from "./GarageUpdates.vue?vue&type=script&lang=js"
import style0 from "./GarageUpdates.vue?vue&type=style&index=0&id=18673736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18673736",
  null
  
)

export default component.exports